exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FocusedCBGSliceSegment--segment--3hWTM{stroke:#000;stroke-width:2;pointer-events:none;fill:transparent}", ""]);

// exports
exports.locals = {
	"stroke": "2",
	"segment": "FocusedCBGSliceSegment--segment--3hWTM"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/cbg/FocusedCBGSliceSegment.css
 ** module id = 143
 ** module chunks = 0
 **/